const elements = document.querySelectorAll("section > *");
const config = {
  //root:0,
  rootMargin: window.innerWidth >= 768 ? "400px 0px -70px 0px" : "400px 0px 0px 0px" ,
  threshold: .1,
};

let observer = new IntersectionObserver(function (entries, self) {
  
  entries.forEach(entry => {

    if(entry.isIntersecting) {

      animElements(entry.target)
      self.unobserve(entry.target)
    }
  })
}, config);

elements.forEach(elt => {
  observer.observe(elt);
})

function animElements(elt) {
  
  elt.style.opacity = '1';
  elt.style.transform = 'translateY(0)';
}
